import { ordersApi } from "./orders";

export const {
  useGetConsolidationSummaryQuery,
  useGetOrdersQuery,
  useGetOrderFiltersQuery,
  useGetOrderSummariesQuery,
  useGetPaginatedOrderSummariesInfiniteQuery,
  useGetOrderTypesQuery,
  useLazyGetOrdersQuery,
  usePostUnstallOrderMutation,
  usePostBatchesFromOrdersMutation,
  useCreateOrderTypeMutation,
  useDeleteOrderTypeMutation
} = ordersApi;
